import React from 'react';
import {withScriptjs, withGoogleMap, GoogleMap, Marker, InfoWindow} from "react-google-maps"

// 1.	Name
// 2.	Address line + Postal code + City
// 3.	Main phone + Mobile phone
// 4.	E-mail

function Info({name, addressLine, zipCode, city, phoneNo, mobileNo, mapEmail}) {
    return (
        <div className="font-weight-bold">
            <div>{name}</div>
            <div>{`${addressLine || ''}, ${zipCode || ''}, ${city || ''}`}</div>
            <div>{`Tηλ. ${phoneNo || ''}, Κιν. ${mobileNo || ''}`}</div>
            <div>{mapEmail}</div>
        </div>
    )
}

function PartnerInfo({partner, isOpen, onCloseClick}) {
    if (isOpen) {
        return (
            <InfoWindow onCloseClick={onCloseClick}>
                <Info {...partner}/>
            </InfoWindow>
        )
    }
    return null;
}


function PartnerMarker({partner, position, isOpen, onClick, onCloseClick}) {
    return (
        <Marker position={position} onClick={onClick}>
            <PartnerInfo partner={partner} isOpen={isOpen} onCloseClick={onCloseClick}/>
        </Marker>
    )
}


const PartnersMap = withScriptjs(withGoogleMap
(({
      center, zoom, partners, currentPartner, onMarkerClick, onInfoWindowClose, defaultZoom, onMapLoad
  }
) => {
    return (
        <GoogleMap
            ref={onMapLoad}
            defaultZoom={defaultZoom}
            zoom={zoom}
            defaultCenter={center}
            center={center}
            options={{disableDefaultUI: true}}
        >
            {
                partners.map((partner, idx) => {
                    const {latitude, longitude} = partner;
                    const markerProps = {
                        partner,
                        position: {lat: latitude, lng: longitude},
                        onClick: () => onMarkerClick(idx),
                        onCloseClick: () => onInfoWindowClose(idx),
                        isOpen: idx === currentPartner
                    };
                    return (
                        <PartnerMarker key={idx} {...markerProps} />
                    )
                })
            }
        </GoogleMap>
    )
}));

export default PartnersMap;
